'use client';

import { usePathname } from 'next/navigation';

import { TextButton } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

const noAccountPages = ['/login'];
const hasAccountPages = ['/signup', '/select-nationality'];

const authConditionalInfoOptions = {
  noAccount: {
    title: 'Don’t have an account?',
    buttonText: 'Sign up',
    href: '/signup',
  },
  hasAccount: {
    title: 'Already signed up?',
    buttonText: 'Log in',
    href: '/login',
  },
};

const getConditionalInfo = (pathname: string) => {
  if (noAccountPages.some((p) => pathname.includes(p))) return authConditionalInfoOptions.noAccount;
  if (hasAccountPages.some((p) => pathname.includes(p))) return authConditionalInfoOptions.hasAccount;
  return null;
};
const SessionNudgeButton = () => {
  const pathname = usePathname();

  const conditionalInfo = getConditionalInfo(pathname);

  if (!conditionalInfo) return null;

  return (
    <div className={hstack({ bgColor: 'background.accent.promotion.tint', rounded: 8, p: 16, w: '100%' })}>
      <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5' })}>{conditionalInfo.title} </p>

      <TextButton
        size='large'
        as='a'
        href={conditionalInfo.href}
        label={conditionalInfo.buttonText}
        css={{ ml: 'auto' }}
      />
    </div>
  );
};

export default SessionNudgeButton;
